<template>
  <modal
    id="tenant-create-edit-modal"
    v-model="showModal"
    :title="selectedUrl ? $editLabel('tenant') : $addLabel('tenant')"
    @submit="submitData"
    :loading="loading"
    :preloader="preloader"
  >
    <form
      :data-url="selectedUrl ? selectedUrl : TENANTS_API"
      ref="form"
      @submit.prevent="submitData"
    >
      <app-form-group
        :label="$t('name')"
        v-model="formData.name"
        :placeholder="$placeholder('name', '')"
        :error-message="$errorMessage(errors, 'name')"
      />

      <app-form-group
        :label="$t('short_name')"
        v-model="formData.short_name"
        :placeholder="$placeholder('short_name', '')"
        :error-message="$errorMessage(errors, 'short_name')"
      />

      <app-form-group
        type="select"
        :label="$t('status')"
        v-model="formData.is_active"
        :list="statusList"
        :error-message="$errorMessage(errors, 'is_active')"
      />
    </form>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import { TENANTS_API } from "../../../Config/ApiUrl";

export default {
  name: "TenantCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin],
  data() {
    return {
      TENANTS_API,
      formData: {
        name: "",
        short_name: "",
        is_active: 1,
      },
      statusList: [
        { id: 1, value: this.$t("active") },
        { id: 0, value: this.$t("inactive") },
      ],
    };
  },
  methods: {
    afterSuccess({ data }) {
      this.toastAndReload(
        data.message || this.$t("saved_successfully"),
        "app-tenants-table",
      );
      this.formData = { name: "", short_name: "", is_active: 1 };
      $("#tenant-create-edit-modal").modal("hide");
    },
    afterSuccessFromGetEditData(response) {
      this.preloader = false;
      this.formData = {
        ...response.data,
        is_active: response.data.is_active ? 1 : 0,
      };
    },
  },
};
</script>
